export const PUBLIC_SUFFIX_URL =
  "https://publicsuffix.org/list/public_suffix_list.dat";
export const PUBLIC_SUFFIX_MARKER_ICANN_START = "// ===BEGIN ICANN DOMAINS===";
export const PUBLIC_SUFFIX_MARKER_ICANN_END = "// ===END ICANN DOMAINS===";
export const PUBLIC_SUFFIX_MARKER_PRIVATE_START =
  "// ===BEGIN PRIVATE DOMAINS===";
export const PUBLIC_SUFFIX_MARKER_PRIVATE_END = "// ===END PRIVATE DOMAINS===";
export const FETCH_PSL_EXPECTED_MIN_LENGTH = 313_150;
